export const name = "ST_NUMPOINTS";
export const summary = `Gets the number of vertices in the a \`GEOGRAPHY\` value.`;
export const reference = `
## ST_NUMPOINTS

Gets the number of vertices in the a \`GEOGRAPHY\` value.

\`\`\`
ST_NUMPOINTS(geography_expression)
\`\`\`

### Description

Returns the number of vertices in the input\`GEOGRAPHY\`. This includes the number of points, the number of linestring vertices, and the number of polygon vertices.

NOTE: The first and last vertex of a polygon ring are counted as distinct vertices.


### Return type

\`INT64\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
